<template>
  <div>
    <div v-if="error" class="">
      <div class="alert alert-warning alert-dismissible">
        <span class="text-sm">Email or Password Invalid</span>
        <button type="button" class="close" aria-label="Close" @click="() => (error = false)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <BushelTextInputMaterial
      v-if="!show2fa"
      type="email"
      name="email"
      autofocus
      :label-active="'Email'"
      :error="submitted && !validateEmail(formData.email)"
      autocomplete="email"
      :value="formData.email"
      :error-text="'Required'"
      @input="(email) => (formData.email = email)"
    />
    <BushelTextInputMaterial
      v-if="!show2fa"
      :type="showPassword ? 'text' : 'password'"
      name="password"
      :error="submitted && formData.password.length < 8"
      :error-text="'8 char min, letters, mixedCase, numbers, symbols'"
      :label-active="'Password'"
      :value="formData.password"
      :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
      :message="'8 char min, letters, mixedCase, numbers, symbols'"
      @icon-clicked="showPassword = !showPassword"
      @input="(password) => (formData.password = password)"
    />
    <BushelTextInputMaterial
      v-if="show2fa"
      ref="twofa"
      autofocus
      type="number"
      :label-active="'Authy Token'"
      :error="submitted && !formData.token"
      :value="formData.token"
      :error-text="'Required'"
      :message="'Please use the Authy App on your phone to login'"
      @input="on2faInput"
    />
    <BushelBtn v-if="!show2fa" class="btn-block mt-4" variant="success" @click="submit">
      Login
      <div v-if="submitting" class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </BushelBtn>
    <BushelBtn v-if="show2fa" class="btn-block mt-4" variant="success" @click="submit">
      Verify
      <div v-if="submitting" class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </BushelBtn>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import BushelTextInputMaterial from "@/components/common/forms/BushelTextInputMaterial.vue";
import { validateEmail } from "@/services/helpers";

export default {
  components: {
    BushelTextInputMaterial,
  },
  props: {},
  emits: ["loggedIn"],
  data() {
    return {
      submitted: false,
      submitting: false,
      showPassword: false,
      show2fa: false,
      error: false,
      formData: {
        email: "",
        password: "",
        token: "",
      },
    };
  },
  methods: {
    ...mapActions({
      login: "auth/loginProfileWidget",
    }),
    validateEmail,
    on2faInput($event) {
      this.formData.token = $event;
    },
    submit() {
      this.submitted = true;
      this.submitting = true;
      this.error = false;

      if (this.isValid()) {
        const payload = { email: this.formData.email, token: this.formData.token, password: this.formData.password };
        this.login(payload).then(
          (response) => {
            this.submitting = false;
            if (response === "success") {
              this.$emit("loggedIn", response);
            } else if (response === "two factor enabled") {
              this.submitted = false;
              this.show2fa = true;
            } else {
              this.error = true;
            }
          },
          (error) => {
            this.error = true;
            this.submitting = false;
          },
        );
      } else {
        this.error = true;
        this.submitting = false;
      }
    },
    isValid() {
      return this.validateEmail(this.formData.email) && this.formData.password.length >= 8;
    },
  },
};
</script>
